import React, { useContext } from "react";
import { ProfileContext } from "../context/ProfileContext";
import {
  IonAvatar,
  IonItem,
  IonLabel,
  IonButton,
  IonList,
  useIonAlert,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import "../theme/AppStyles.css";
import { fx_FB_MarkAssociateRequestRead } from "../functions/Fx_AssociateFunctions";
import { ASSOCIATESTATUS_TYPES } from "../functions/postActionTypes";
import { useAssociateRequestHandlers } from "../hooks/useAssociateRequestHandlers";

interface AssociateUser {
  WerkerUid: string;
  WerkerFirstName: string;
  WerkerLastName: string;
  WerkerCompany: string;
  WerkerProfilePicURL: string;
  WerkerBio: string;
  AssociateStatus: string;
  isRead_Request: boolean;
}

interface AssociatesListProps {
  associatesList: AssociateUser[];
}

export const AssociatesList: React.FC<AssociatesListProps> = ({
  associatesList,
}) => {
  const history = useHistory();
  const { buttonColor, profile } = useContext(ProfileContext);
  const [present] = useIonAlert();

  const {
    handleSendRequest,
    handleCancelRequest,
    handleAcceptRequest,
    handleDeclineRequest,
  } = useAssociateRequestHandlers({
    profile,
    presentAlert: present,
  });

  // Clear badge on request notification when opening associate profile
  const handleClearOneBadge_Request = async (
    associatesUID: string,
    isREAD: boolean
  ) => {
    if (isREAD === false) {
      await fx_FB_MarkAssociateRequestRead(profile.UserId, associatesUID);
    }
  };

  return (
    <React.Fragment>
      <IonList
      >
        {associatesList
          // filter out any special/system user if needed
          .filter((value) => {
            if (
              value.WerkerUid !== "nZhDwrvpfbRWoQz3P6VTdZR8nrp2" &&
              value.WerkerUid !== ""
            ) {
              return true;
            }
            return false;
          })
          // Remove duplicates by WerkerUid
          .filter((value, index, self) => 
            index === self.findIndex((t) => t.WerkerUid === value.WerkerUid)
          )
          .map((user) => (
            <IonItem
              key={user.WerkerUid}
            >
              <IonAvatar
                className="avatario"
                slot="start"
                onClick={(e) => {
                  e.preventDefault();
                  handleClearOneBadge_Request(
                    user.WerkerUid,
                    user.isRead_Request
                  )
                    .catch(() => {})
                    .finally(() => {
                      history.push(`/AssociateProfile/${user.WerkerUid}`);
                    });
                }}
              >
                <img src={user.WerkerProfilePicURL} alt="" />
              </IonAvatar>

              <IonLabel
                className="labelo"
              >
                <h2
                  onClick={() => {
                    handleClearOneBadge_Request(
                      user.WerkerUid,
                      user.isRead_Request
                    )
                      .catch(() => {})
                      .finally(() => {
                        history.push(`/AssociateProfile/${user.WerkerUid}`);
                      });
                  }}
                >
                  {user.WerkerFirstName} {user.WerkerLastName}
                </h2>
                <p
                  onClick={() => {
                    handleClearOneBadge_Request(
                      user.WerkerUid,
                      user.isRead_Request
                    )
                      .catch(() => {})
                      .finally(() => {
                        history.push(`/AssociateProfile/${user.WerkerUid}`);
                      });
                  }}
                >
                  {user.WerkerCompany}
                </p>
                <p></p>

                {/* {user.isRead_Request === false && (
                  <IonIcon
                    icon={eyeOutline}
                    size="large"
                    color={"danger"}
                  />
                )} */}

                {user.AssociateStatus === ASSOCIATESTATUS_TYPES.RequestSent && (
                  <IonItem
                    lines="none"
                  >
                    <IonButton
                      slot="end"
                      size="small"
                      color={buttonColor}
                    >
                      Request Sent
                    </IonButton>
                    <IonButton
                      slot="end"
                      size="small"
                      color="medium"
                      onClick={() =>
                        handleCancelRequest(
                          user.WerkerUid,
                          user.WerkerFirstName,
                          user.WerkerLastName,
                          user.WerkerCompany,
                          user.WerkerProfilePicURL
                        )
                      }
                    >
                      Cancel
                    </IonButton>
                  </IonItem>
                )}

                {user.AssociateStatus ===
                  ASSOCIATESTATUS_TYPES.RequestReceived && (
                  <IonItem
                    lines="none"
                  >
                    <IonButton
                      slot="end"
                      size="small"
                      color={buttonColor}
                      onClick={() =>
                        handleAcceptRequest(
                          user.WerkerUid,
                          user.WerkerFirstName,
                          user.WerkerLastName,
                          user.WerkerCompany,
                          user.WerkerProfilePicURL
                        )
                      }
                    >
                      Accept?
                    </IonButton>
                    <IonButton
                      slot="end"
                      size="small"
                      color="medium"
                      onClick={() =>
                        handleDeclineRequest(
                          user.WerkerUid,
                          user.WerkerFirstName,
                          user.WerkerLastName,
                          user.WerkerCompany,
                          user.WerkerProfilePicURL
                        )
                      }
                    >
                      Not Now
                    </IonButton>
                  </IonItem>
                )}

                {user.AssociateStatus === "Everyone" && (
                  <IonItem
                    lines="none"
                  >
                    <IonButton
                      slot="end"
                      size="small"
                      color={buttonColor}
                      onClick={() =>
                        handleSendRequest(
                          user.WerkerUid,
                          user.WerkerFirstName,
                          user.WerkerLastName,
                          user.WerkerCompany,
                          user.WerkerProfilePicURL
                        )
                      }
                    >
                      Send Request?
                    </IonButton>
                  </IonItem>
                )}

                <br />
              </IonLabel>
            </IonItem>
          ))}
      </IonList>
    </React.Fragment>
  );
};
